import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "Section login-form"
};
var _hoisted_2 = {
  "class": "p-2xl"
};
var _hoisted_3 = {
  "class": "inputs"
};
var _hoisted_4 = {
  "class": "relative"
};
var _hoisted_5 = {
  key: 0,
  "class": "absolute left-1/2 -translate-x-1/2 whitespace-nowrap bottom-full shadow-lg px-lg py-sm text-sm rounded-md leading-[1.4] z-[20001] text-white bg-secondary border border-solid border-zinc-700"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
var _hoisted_7 = {
  "class": "login-form__actions"
};
var _hoisted_8 = {
  "class": "text-center"
};
var _hoisted_9 = {
  "class": "login-form__disclaimer flex items-center"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " A minimum of 100,000 USD (or its equivalent) deposit is required to use Prime Brokerage services ", -1);
var _hoisted_11 = {
  key: 1,
  "class": "p-2xl"
};
import { notify } from "@/utils/notifications";
import registerSuite from "@/validators/registerSuite";

import { useStore } from 'vuex';
import { reactive, ref, computed } from 'vue';
export default {
  __name: 'Register',
  setup: function setup(__props) {
    var store = useStore();
    var form = reactive({
      email: null,
      password: null,
      confirmPassword: null,
      recaptchaToken: "",
      agree: null
    });
    var emailAlert = ref(false);
    var error = ref(null);
    var loading = ref(false);
    var passwordOn = ref(true);
    var confirmPasswordOn = ref(true);
    var passwordType = computed(function () {
      return passwordOn.value ? "password" : "text";
    });
    var confirmPasswordType = computed(function () {
      return confirmPasswordOn.value ? "password" : "text";
    });
    var validationResult = computed(function () {
      return registerSuite(form);
    });
    function unsetError() {
      error.value = null;
    }
    function submit() {
      return _submit.apply(this, arguments);
    }
    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _e$response$data$mess, _e$response, text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!validationResult.value.isValid() || loading.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              unsetError();
              loading.value = true;
              _context.prev = 4;
              _context.next = 7;
              return store.dispatch("auth/register", form);
            case 7:
              _context.next = 16;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](4);
              text = (_e$response$data$mess = _context.t0 === null || _context.t0 === void 0 || (_e$response = _context.t0.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.message) !== null && _e$response$data$mess !== void 0 ? _e$response$data$mess : "Something went wrong";
              form.recaptchaToken = "";
              error.value = text;
              loading.value = false;
              notify({
                text: text
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 9]]);
      }));
      return _submit.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_PBInput = _resolveComponent("PBInput");
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBCheckbox = _resolveComponent("PBCheckbox");
      var _component_Captcha = _resolveComponent("Captcha");
      var _component_PBButton = _resolveComponent("PBButton");
      var _component_RouterLink = _resolveComponent("RouterLink");
      var _component_PBStatus = _resolveComponent("PBStatus");
      return _openBlock(), _createElementBlock("div", null, [!_unref(store).state.auth.user ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_PBInput, {
        modelValue: _unref(form).email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(form).email = $event;
        }),
        label: "Email",
        placeholder: "Enter email address",
        icon: "envelope",
        error: _unref(validationResult).getErrors('email')[0],
        "class": "mb-2xl w-full",
        onEnter: submit,
        onKeyup: unsetError,
        onFocus: _cache[1] || (_cache[1] = function ($event) {
          return emailAlert.value = true;
        }),
        onBlur: _cache[2] || (_cache[2] = function ($event) {
          return emailAlert.value = false;
        })
      }, null, 8, ["modelValue", "error"]), _unref(emailAlert) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode(" If you already have a bequant.io account,"), _hoisted_6, _createTextVNode("please use a different email address. ")])) : _createCommentVNode("", true)]), _createVNode(_component_PBInput, {
        modelValue: _unref(form).password,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _unref(form).password = $event;
        }),
        label: "Password",
        placeholder: "Enter password",
        icon: "lock",
        error: _unref(validationResult).getErrors('password')[0],
        type: _unref(passwordType),
        "class": "mb-2xl",
        onEnter: submit,
        onKeyup: unsetError
      }, {
        append: _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            "class": "text-zinc-500 cursor-pointer",
            name: _unref(passwordOn) ? 'eye-off' : 'eye',
            w: 22,
            h: 22,
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return passwordOn.value = !_unref(passwordOn);
            })
          }, null, 8, ["name"])];
        }),
        _: 1
      }, 8, ["modelValue", "error", "type"]), _createVNode(_component_PBInput, {
        modelValue: _unref(form).confirmPassword,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _unref(form).confirmPassword = $event;
        }),
        label: "Confirm Password",
        placeholder: "Confirm password",
        icon: "lock",
        error: _unref(validationResult).getErrors('confirmPassword')[0],
        type: _unref(confirmPasswordType),
        "class": "mb-2xl",
        onEnter: submit,
        onKeyup: unsetError
      }, {
        append: _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            "class": "text-zinc-500 cursor-pointer",
            name: _unref(confirmPasswordOn) ? 'eye-off' : 'eye',
            w: 22,
            h: 22,
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return confirmPasswordOn.value = !_unref(confirmPasswordOn);
            })
          }, null, 8, ["name"])];
        }),
        _: 1
      }, 8, ["modelValue", "error", "type"]), _createVNode(_component_PBCheckbox, {
        modelValue: _unref(form).agree,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
          return _unref(form).agree = $event;
        }),
        error: _unref(validationResult).getErrors('agree')[0],
        small: "",
        "class": "mb-2xl",
        label: "agree"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" I understand and agree to the "), _createElementVNode("a", {
            href: "https://bequant.pro/terms-of-service",
            "class": "text-primary border-b border-solid border-primary",
            target: "_blank",
            onClick: _cache[7] || (_cache[7] = _withModifiers(function () {}, ["stop"]))
          }, "terms of business"), _createTextVNode(". ")];
        }),
        _: 1
      }, 8, ["modelValue", "error"]), _createVNode(_component_Captcha, {
        modelValue: _unref(form).recaptchaToken,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return _unref(form).recaptchaToken = $event;
        }),
        theme: "dark",
        "class": "mb-2xl"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_PBButton, {
        full: "",
        disabled: !_unref(validationResult).isValid(),
        loading: _unref(loading),
        large: "",
        "class": "mb-2xl",
        onClick: submit
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Sign up ")];
        }),
        _: 1
      }, 8, ["disabled", "loading"]), _createElementVNode("div", _hoisted_8, [_createTextVNode(" Already have an account? "), _createVNode(_component_RouterLink, {
        to: "/login"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Log in ")];
        }),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_PBIcon, {
        name: "warning",
        w: 24,
        h: 21
      }), _hoisted_10])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_PBStatus, {
        empty: "",
        message: "Welcome to BEQUANT Pro"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" To login, please confirm your email address by clicking the Finish signup button in the email we’ve just sent to Your email address. ")];
        }),
        _: 1
      })]))]);
    };
  }
};